import { KLoggerDirect1gyffbbrrlqc0 as KLoggerDirect } from './internal/KLoggerDirect.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DirectLoggerFactoryClass;
function DirectLoggerFactory() {
  if (DirectLoggerFactoryClass === VOID) {
    class $ {
      logger_ivxpna_k$(name) {
        return new (KLoggerDirect())(name);
      }
    }
    initMetadataForObject($, 'DirectLoggerFactory');
    DirectLoggerFactoryClass = $;
  }
  return DirectLoggerFactoryClass;
}
var DirectLoggerFactory_instance;
function DirectLoggerFactory_getInstance() {
  return DirectLoggerFactory_instance;
}
//region block: init
DirectLoggerFactory_instance = new (DirectLoggerFactory())();
//endregion
//region block: exports
export {
  DirectLoggerFactory_instance as DirectLoggerFactory_instance2bis64rb1elo9,
};
//endregion

//# sourceMappingURL=DirectLoggerFactory.mjs.map
